import React, { useState, useEffect } from "react";
import { Spin } from "antd";

const imageCache = new Map();

const CardImageItem = ({ fileName, token }) => {
  const [loading, setLoading] = useState(true);
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    if (!fileName || !token) return;

    const cacheKey = `${fileName}`;

    // ✅ CACHE HIT
    if (imageCache.has(cacheKey)) {
      setImageSrc(imageCache.get(cacheKey));
      setLoading(false);
      return;
    }

    let isMounted = true;

    const fetchImage = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/files/print/${fileName}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);

        imageCache.set(cacheKey, url);

        if (isMounted) {
          setImageSrc(url);
          setLoading(false);
        }
      } catch (error) {
        console.error("Erreur image:", error);
        if (isMounted) {
          setImageSrc(null);
          setLoading(false);
        }
      }
    };

    fetchImage();

    return () => {
      isMounted = false;
    };
  }, [fileName, token]);

  if (!fileName) {
    return <span>Pas d'image</span>;
  }

  return (
    <div style={{ position: "relative", textAlign: "center" }}>
      {loading && <Spin size="small" />}

      {imageSrc && (
        <img
          src={imageSrc}
          alt="Image"
          style={{
            display: loading ? "none" : "block",
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      )}
    </div>
  );
};

export default React.memo(CardImageItem);

// import React, { useState, useEffect } from "react";
// import { Image, Spin } from "antd";

// const CardImageItem = ({ fileName, token }) => {
//   const [loading, setLoading] = useState(true);
//   const [imageSrc, setImageSrc] = useState(null);

//   const handleImageLoad = () => setLoading(false);
//   const handleImageError = () => setLoading(false);

//   useEffect(() => {
//     if (!fileName || !token) return;

//     const fetchImage = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}/files/print/${fileName}`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         const blob = await response.blob();
//         const url = URL.createObjectURL(blob);
//         setImageSrc(url);
//       } catch (error) {
//         console.error("Erreur lors du chargement de l'image:", error);
//         setImageSrc(null);
//       }
//     };

//     fetchImage();

//     return () => {
//       if (imageSrc) {
//         URL.revokeObjectURL(imageSrc);
//       }
//     };
//   }, [fileName, token]);

//   if (!fileName) {
//     return <h4 className="text-center">Pas d'image </h4>;
//   }

//   return (
//     <div className="image-container" style={{ position: "relative", textAlign: "center" }}>
//       {loading && (
//         <div className="loading-spinner mt-3">
//           <p>Chargement, merci de patienter...</p>
//           <Spin size="large" className="text-center" />
//         </div>
//       )}

//       {imageSrc && (
//         <img
//           src={imageSrc}
//           alt="Image"
//           className="img-fluid"
//           onLoad={handleImageLoad}
//           onError={handleImageError}
//           style={{
//             display: loading ? "none" : "block",
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//           }}
//         />
//       )}
//     </div>
//   );
// };

// export default CardImageItem;
